/**
 *   Generated file. Do not edit
 */

import { DataLogOption } from './models';
import { SinglePacket } from '@iotize/tap/service/impl/single-packet';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readDataLogOption(): DataLogOption;
  }
  export interface TapStreamWriter {
    writeDataLogOption(model: DataLogOption): TapStreamWriter;
  }
}

TapStreamReader.prototype.readDataLogOption = function (): DataLogOption {
  const model: Partial<DataLogOption> = {};

  this.forwardBits(6);

  model.security = this.readBoolean(1);

  model.qos = this.readBoolean(1);

  this.forwardBits(5);

  model.logOnChange = this.readBoolean(1);

  model.rollingMode = this.readBoolean(1);

  model.autorun = this.readBoolean(1);

  return model as DataLogOption;
};

// TapStreamWriter.prototype.write(model: DataLogOption) : TapStreamWriter{
//     return this.writeDataLogOption(model)
// }

TapStreamWriter.prototype.writeDataLogOption = function (
  model: DataLogOption,
): TapStreamWriter {
  this.forwardBits(6);

  this.writeBoolean(model.security, 1);

  this.writeBoolean(model.qos, 1);

  this.forwardBits(5);

  this.writeBoolean(model.logOnChange, 1);

  this.writeBoolean(model.rollingMode, 1);

  this.writeBoolean(model.autorun, 1);

  return this;
};
